module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/82f3a23157b2ab798ed5917e1cf29298.png";